import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';

import { BtiErrorDataPopup, IBtiErrorDataPopupDispatchProps, IBtiErrorDataPopupProps } from './index';

import { closeBtiDataErrorPopup, submitFeedback } from '../../store/bti_error_data_popup';

function mapStateToProps(state: IState): IBtiErrorDataPopupProps {
  const { error, isOpen, statusFetch } = state.btiErrorData;

  return {
    error,
    isOpen,
    statusFetch,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IBtiErrorDataPopupDispatchProps {
  return {
    closeBtiDataErrorPopup: () => {
      dispatch(closeBtiDataErrorPopup());
    },
    submitFeedback: (host: string, email: string, message: string, url: string) => {
      dispatch(submitFeedback(host, email, message, url));
    },
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BtiErrorDataPopupContainer = connect<IBtiErrorDataPopupProps, IBtiErrorDataPopupDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps,
)(BtiErrorDataPopup);
